var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "fullscreen",
        attrs: {
          onclick:
            "document.querySelector('body').webkitRequestFullscreen();this.remove()",
        },
      },
      [_vm._v("Fullscreen")]
    ),
    _vm._v(" "),
    _vm.box
      ? _c("section", { staticClass: "wrapper wrapper--mobile" }, [
          _c("section", { staticClass: "pickup" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "pickup__middle" }, [
              _c("div", { staticClass: "pickup__number" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$options.filters.fwgshortorder(_vm.box.number)
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pickup__arrow" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.asset(_vm.themeValue("THEME_PAYMENT_ARROW")),
                      alt: "",
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pickup__name" }, [
                _vm._v(_vm._s(_vm.box.order_label)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pickup__bottom" }, [
              _c(
                "a",
                {
                  staticClass: "pickup__button button button--primary",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.onPickup },
                },
                [_vm._v("Hol deine Bestellung ab")]
              ),
            ]),
          ]),
        ])
      : _c(
          "section",
          { staticClass: "wrapper wrapper--mobile wrapper--no-margin" },
          [
            _c("section", { staticClass: "pickup pickup--empty" }, [
              _c("div", { staticClass: "pickup__empty" }, [
                _vm._v(
                  "\n          « BOX " + _vm._s(_vm.boxNumber) + " »\n        "
                ),
              ]),
            ]),
          ]
        ),
    _vm._v(" "),
    _vm.showSuccess
      ? _c("section", { staticClass: "thank-you" }, [_vm._m(1)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pickup__top" }, [
      _c("h3", [_vm._v("Bestellung zur Abholung bereit")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wrapper wrapper--mobile" }, [
      _c("div", { staticClass: "thank-you__text" }, [
        _c("h1", [_vm._v("Thank you for your order")]),
        _vm._v(" "),
        _c("span", [_vm._v("See you soon!")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }